export default {
    props: {
        document: {
            type: Object,
            required: false,
            default: null
        },
        sliceOpen: {
            type: String,
            required: false,
            default: ''
        },
        breakpoint: {
            type: Number,
            required: false,
            default: 900
        }
    },
    data() {
        return {
            show: false,
            currentChildSliceOpen: ''
        };
    },
    watch: {
        currentSliceOpen() {
            if (this.show === true && this.sliceOpen !== this.document.id) {
                this.show = false;
            }
        },
        '$route.path': {
            handler: function() {
                this.show = false;
            }
        }
    },
    computed: {
        currentSliceOpen() {
            return this.sliceOpen;
        }
    },
    methods: {
        updateSliceId(value) {
            this.currentChildSliceOpen = value;
        },
        onEnter() {
            if (window.innerWidth > this.breakpoint) {
                this.show = true;
            }
        },
        onLeave() {
            if (window.innerWidth > this.breakpoint) {
                this.show = false;
            }
        },
        toggle() {
            this.show = ! this.show;
            if (this.show === true) {
                return this.$emit('expandedSlice', this.document.id);
            }
        },
    }
};